import { render, staticRenderFns } from "./UsersChat.vue?vue&type=template&id=968d8000&scoped=true"
import script from "./UsersChat.vue?vue&type=script&lang=js"
export * from "./UsersChat.vue?vue&type=script&lang=js"
import style0 from "./UsersChat.vue?vue&type=style&index=0&id=968d8000&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "968d8000",
  null
  
)

export default component.exports